<template>
  <b-avatar
    class="user-image"
    :class="image && 'image-hover'" 
    :text="name"
    :src="image"
  >
  </b-avatar>
</template>

<script>
export default {
  name: "ImageCell",
  props: ["image", "name"],
};
</script>

<style lang="scss" scoped>
.user-image {
  background-color: #A8CCF7;
  color: #2680EB;
  font-weight: 700;
  font-size: 16px;
}
.image-hover {
  cursor: pointer;
  &:hover {
    transform: scale(7.5);
    z-index: 1000;
    position: relative;
    inset-inline-start: 140px;
  }
}
</style>
<style lang="scss">
.b-avatar {
  width: 27px;
  height: 27px;
}
</style>
